export const PERMISSIONS = Object.freeze({
  INCIDENT_RESOLVER: 'incidentResolver',
  SN_ANALYSIS: 'snAnalysis',
  RUNBOOKS: 'runbooks',
  PROD_PERFORMANCE: 'prodPerformance',
  TRIBE_PERFORMANCE: 'tribePerformance',
  AI_GOVERNANCE: 'aiGovernance',
  MODIFY: 'modify',
  INVOKE_SN_AGENT: 'invokeSnAgent',
  INVOKE_CEP_AGENT: 'invokeCepAgent',
});

const roleAccessConfig = {
  defaultRoleLabel: 'User',
  roles: [
    {
      key: 'ADMIN',
      displayName: 'Administrator',
      priority: 1,
      group: 'resolveguru-admins',
      permissions: [
        PERMISSIONS.INCIDENT_RESOLVER,
        PERMISSIONS.SN_ANALYSIS,
        PERMISSIONS.RUNBOOKS,
        PERMISSIONS.PROD_PERFORMANCE,
        PERMISSIONS.TRIBE_PERFORMANCE,
        PERMISSIONS.AI_GOVERNANCE,
        PERMISSIONS.MODIFY,
        PERMISSIONS.INVOKE_SN_AGENT,
        PERMISSIONS.INVOKE_CEP_AGENT,
      ],
    },
    {
      key: 'OPS_ENGG',
      displayName: 'Operations Engineer',
      priority: 4,
      group: 'resolveguru-ops-engg',
      permissions: [
        PERMISSIONS.INCIDENT_RESOLVER,
        PERMISSIONS.AI_GOVERNANCE,
        PERMISSIONS.INVOKE_SN_AGENT,
        PERMISSIONS.INVOKE_CEP_AGENT,
      ],
    },
    {
      key: 'OPS_SPECIALIST',
      displayName: 'Operations Specialist',
      priority: 3,
      group: 'resolveguru-ops-specialist',
      permissions: [
        PERMISSIONS.INCIDENT_RESOLVER,
        PERMISSIONS.RUNBOOKS,
        PERMISSIONS.TRIBE_PERFORMANCE,
        PERMISSIONS.AI_GOVERNANCE,
        PERMISSIONS.MODIFY,
        PERMISSIONS.INVOKE_SN_AGENT,
        PERMISSIONS.INVOKE_CEP_AGENT,
      ],
    },
    {
      key: 'PRODUCT_OWNER',
      displayName: 'Product Owner',
      priority: 2,
      group: 'resolveguru-product-owner',
      permissions: [
        PERMISSIONS.INCIDENT_RESOLVER,
        PERMISSIONS.SN_ANALYSIS,
        PERMISSIONS.PROD_PERFORMANCE,
        PERMISSIONS.TRIBE_PERFORMANCE,
        PERMISSIONS.AI_GOVERNANCE,
        PERMISSIONS.INVOKE_SN_AGENT,
        PERMISSIONS.INVOKE_CEP_AGENT,
      ],
    },
    {
      key: 'ENGINEERING_LEAD',
      displayName: 'Engineering Lead',
      priority: 2,
      group: 'resolveguru-engineering-lead',
      permissions: [
        PERMISSIONS.INCIDENT_RESOLVER,
        PERMISSIONS.SN_ANALYSIS,
        PERMISSIONS.PROD_PERFORMANCE,
        PERMISSIONS.TRIBE_PERFORMANCE,
        PERMISSIONS.AI_GOVERNANCE,
        PERMISSIONS.INVOKE_SN_AGENT,
        PERMISSIONS.INVOKE_CEP_AGENT,
      ],
    },
    {
      key: 'INDIA_FRONTLINE',
      displayName: 'India Frontline',
      priority: 5,
      group: 'resolveguru-24/7-india-frontline',
      permissions: [PERMISSIONS.SN_ANALYSIS, PERMISSIONS.INVOKE_SN_AGENT],
    },
    {
      key: 'FINLAND_FRONTLINE',
      displayName: 'Finland Frontline',
      priority: 5,
      group: 'resolveguru-24/7-finland-frontline',
      permissions: [PERMISSIONS.SN_ANALYSIS, PERMISSIONS.INVOKE_SN_AGENT],
    },
  ],
};

export default roleAccessConfig;
